import { select } from "@assets/scripts/utils";

export default function () {
    let svg = select('.i6')[0]
    if(!svg) return
    svg = svg.contentDocument

    const fingers = select('.finger', svg)
    const tl = new TimelineMax()
    const gear = svg.querySelector('.gear')
    const clock = svg.querySelector('.clock')
    const alert = svg.querySelector('.alert')
    const alerttl = new TimelineMax()
    const check = svg.querySelector('.check')
    const checkRound = svg.querySelector('.check-round')

    alerttl.fromTo(alert, 1.5, { autoAlpha: 0 }, { autoAlpha: 1, ease: SteppedEase.config(1) })
        .repeat(-1)

    tl
        .add(() => {
            TweenMax.fromTo(checkRound, 1, { drawSVG: '0%' }, { drawSVG: '100%', delay: 1, ease: SteppedEase.config(5) })
            TweenMax.fromTo(check, 1, { drawSVG: '0%' }, { drawSVG: '100%', delay: 1, ease: SteppedEase.config(5) })

            TweenMax.fromTo(clock, 1, { rotation: 0 }, { rotation: 180, transformOrigin: '50% 50%', ease: SteppedEase.config(5) })
            TweenMax.fromTo(gear, 2, { rotation: 0 }, { rotation: 360, transformOrigin: '50% 50%', ease: SteppedEase.config(5) })
            TweenMax.fromTo(fingers[0], 0.8, { y: '0%' }, { y: '100%', ease: SteppedEase.config(3) })
            TweenMax.fromTo(fingers[1], 0.8, { y: '0%' }, { y: '-100%', ease: SteppedEase.config(3) })
        })
        .add(() => {
            TweenMax.to(fingers, 1, { y: '0%', ease: SteppedEase.config(3) })
        }, 1)
        .repeatDelay(1)
        .repeat(-1)

    const lights = select('.lights path', svg)
    const lightstl = new TimelineMax()

    lightstl
        .set(lights, { autoAlpha: 0 })
        .set([lights[1], lights[3]], { autoAlpha: 1 })
        .set(lights, { autoAlpha: 0, delay: 0.1 })
        .set([lights[0], lights[7]], { autoAlpha: 1 })
        .set(lights, { autoAlpha: 0, delay: 0.1 })
        .set([lights[4], lights[8], lights[10]], { autoAlpha: 1 })
        .set(lights, { autoAlpha: 0, delay: 0.1 })
        .set([lights[5], lights[6], lights[9]], { autoAlpha: 1 })
        .set(lights, { autoAlpha: 0, delay: 0.1 })
        .set([lights[1], lights[5]], { autoAlpha: 1 })
        .set(lights, { autoAlpha: 0, delay: 0.1 })
        .repeat(-1)
}
